// extracted by mini-css-extract-plugin
export default {"main":"pca-z"};